/* eslint-disable no-magic-numbers */
import Constants from "const/Constants";

export default class Animations {
  static easeIn(time) {
    return Math.pow(time, 3);
  }

  static easeOut(time) {
    return 1 + Math.pow(time - 1, 3);
  }

  static easeInOut(time) {
    return time > 0.5 ? (4 * Math.pow(time - 1, 3)) + 1 : 4 * Math.pow(time, 3);
  }

  static easeOutIn(time) {
    return time < 0.5
      ? Animations.easeOut(time * 2) / 2
      : 0.5 + (Animations.easeIn((time * 2) - 1) / 2);
  }

  static animate(frame, duration = Constants.DEFAULT_ANIMATION_DURATION, easing = Animations.easeInOut, onEnd) {
    let canceled = false;

    const start = Date.now();

    const next = () => {
      if (canceled) return;

      const delta = Date.now() - start;

      if (delta < duration) {
        frame(easing(delta / duration));
        window.requestAnimationFrame(next);

        return;
      }
      frame(1);
      if (onEnd) onEnd();
    };

    window.requestAnimationFrame(next);

    return () => {
      canceled = true;
    };
  }
}
